.root > * {
  margin-bottom: 0.25rem;
  overflow-wrap: break-word;
}

.sourceDisplayWrapper {
  display: flex;
}

.mentionCounter {
  margin-left: 0.25rem;
  color: var(--muted-old);
  transform: translateY(1px);
}
